// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"b6c174a3","628":"d8d96c9a"}[chunkId] + ".chunk.js";
};